import { CHL_COLOR, CHL_LMN_BLEND_COLOR, DEFAULT_LAYER_COLOR, LMN_COLOR } from '../constants/colors';

/**
 * Returns the display color for a layer based purely on CHL/LMN state.
 * Layer type is intentionally ignored — color is driven only by toggle state.
 */
export function getLayerDisplayColor(layer: { canHoldLuminaire: boolean; isIlluminated: boolean }): string {
  if (layer.canHoldLuminaire && layer.isIlluminated) return CHL_LMN_BLEND_COLOR;
  if (layer.canHoldLuminaire) return CHL_COLOR;
  if (layer.isIlluminated) return LMN_COLOR;
  return DEFAULT_LAYER_COLOR;
}
